require("core-js/modules/es6.array.index-of");

module.exports = function (ary, item) {
  var i = -1,
      indexes = [];

  while ((i = ary.indexOf(item, i + 1)) !== -1) {
    indexes.push(i);
  }

  return indexes;
};